/*eslint no-unused-vars: 0*/

const BookSlider = (target) => {
  const initSlider = ($el, params) => {
    $el.slick(params);
    handleFilter($el)
  };

  const handleFilter = $el => {
    const $parent = $el.parent()
    const $filters = $parent.find('.book__filters input[name="book-slider"]')
    $filters.on('change', e => {
      e.preventDefault()
      const value = $parent.find('.book__filters input[name="book-slider"]:checked').val()
      if (value === 'all') {
        $el.slick('slickUnfilter')
      } else {
        $el.slick('slickUnfilter')
        $el.slick('slickFilter', `.${value}`)
      }
    })
  }

  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      const params = {
        arrows: false,
        dots: true,
        rows: 0,
        infinite: false,
        responsive: [
          {
            breakpoint: 9999,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              variableWidth: false,
              dots: false,
              arrows: true,
              prevArrow: '<button class="slick-arrow slick-prev"><i class="icon icon-arrow"></i></button>',
              nextArrow: '<button class="slick-arrow slick-next"><i class="icon icon-arrow"></i></span></button>',
            },
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              variableWidth: false,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.1,
            },
          },
        ],
      }
      initSlider($el, params);

      $(window).on('resize', () => {
        if (!$el.hasClass('slick-initialized')) {
          initSlider($el, params)
        }
      });
    });
}

export default BookSlider;



// WEBPACK FOOTER //
// ./scripts/components/BookSlider.js